import { render } from "./PaymentLinkGeneratorCreateForm.vue?vue&type=template&id=4c6b4e22"
import script from "./PaymentLinkGeneratorCreateForm.vue?vue&type=script&lang=js"
export * from "./PaymentLinkGeneratorCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__